
















































































import Vue from "vue";
import { RoomDetail } from "@/models/room";
import RoomLastCommands from "@/components/dashboard/rooms/room/RoomLastCommands.vue";
import LoggingAndroid from "@/components/dashboard/rooms/room/LoggingAndroid.vue";
import PoliciesChooser from "../policies/PoliciesChooser.vue";
import VaCard from "@/components/molecules/VaCard.vue";
import VaTextField from "@/components/atoms/VaTextField.vue";
import VaButton from "@/components/atoms/VaButton.vue";
import RoomService from "@/services/roomService";
import { RoomCommandTypes } from "@/models/room";
import RemoteProviders from "./RemoteProviders.vue";
import validationMixin from "@/components/mixins/validationMixin";
import { Tag } from "@/models/tag";
import { Group } from "@/models/group";

export default Vue.extend({
  name: "RoomRemoteManagementAndroid",
  components: {
    RoomLastCommands,
    LoggingAndroid,
    PoliciesChooser,
    VaCard,
    VaTextField,
    VaButton,
    RemoteProviders,
  },
  mixins: [validationMixin],
  data() {
    return {
      sending: false,
      updatingTags: false,
      updatingGroup: false,
    };
  },
  beforeMount() {
    this.$store.dispatch("group/fetchAll");
    this.$store.dispatch("tag/fetchList");
  },
  computed: {
    commandControlsDisabled(): boolean {
      return !this.room?.online || !!this.room?.isMaintenanceExpired;
    },
    room(): RoomDetail {
      return this.$store.getters["room/room"];
    },
    isAndroid(): boolean {
      return this.room?.deviceType === "AndroidReceiver";
    },
    tags(): Tag[] {
      return this.$store.getters["tag/tags"];
    },
    groups(): Group[] {
      return this.$store.getters["group/availableGroups"];
    },
    selectedTags: {
      get(): Tag[] {
        return this.room?.tags || [];
      },
      set(tags: Tag[]) {
        this.updateTags(tags);
      },
    },
    group: {
      get(): Group | undefined {
        return this.room?.group;
      },
      set(group: Group) {
        this.updateGroup(group);
      },
    },
  },
  methods: {
    // Same PATCH as the Windows management page (RoomRemoteManagement).
    async updateTags(tags: Tag[]): Promise<void> {
      this.updatingTags = true;
      try {
        const room = await RoomService.patch(this.room.id, {
          tags: tags.map((tag: Tag) => tag.id),
        });
        this.$store.commit("room/updateRoom", room);
        this.$notification.success(this.$t("roomInformation.tagsSuccess"));
      } catch (e) {
        this.$notification.error(e);
        this.$sentry.capture(e, "RoomRemoteManagementAndroid", "updateTags");
      } finally {
        this.updatingTags = false;
      }
    },
    async updateGroup(group: Group): Promise<void> {
      this.updatingGroup = true;
      try {
        const room = await RoomService.patch(this.room.id, {
          groupId: group.id,
        });
        this.$store.commit("room/updateRoom", room);
        this.$notification.success(this.$t("roomInformation.groupSuccess"));
      } catch (e) {
        this.$notification.error(e);
        this.$sentry.capture(e, "RoomRemoteManagementAndroid", "updateGroup");
      } finally {
        this.updatingGroup = false;
      }
    },
    async setName(): Promise<void> {
      if (this.commandControlsDisabled) return;
      this.sending = true;
      try {
        await RoomService.sendCommand(
          RoomCommandTypes.MACHINE_NAME,
          this.room.name
        );
        this.$store.commit("notifications/displayNotification", {
          message: this.$t("roomCommands.commandSuccess"),
          type: "success",
        });
      } catch (e) {
        this.$store.commit("notifications/displayNotification", {
          message: e,
          type: "error",
        });
        this.$sentry.capture(e, "RoomRemoteManagement", "sendCommand");
      } finally {
        this.sending = false;
      }
    },
  },
});
